/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Page_FaqInputs */

const en_landing_pricing_page_faq = /** @type {(inputs: Landing_Pricing_Page_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing questions`)
};

const zh_landing_pricing_page_faq = /** @type {(inputs: Landing_Pricing_Page_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计费常见问题`)
};

/**
* | output |
* | --- |
* | "Billing questions" |
*
* @param {Landing_Pricing_Page_FaqInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_page_faq = /** @type {((inputs?: Landing_Pricing_Page_FaqInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Page_FaqInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_page_faq(inputs)
	return zh_landing_pricing_page_faq(inputs)
});
export { landing_pricing_page_faq as "landing.pricing.page_faq" }